import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import style from './Nodes.style';
import {
    FMCheckbox,
    FMIcon,
    FMIconType,
    FMTreeNode,
    FMTreeItemNodeWithStore,
} from 'atoms';
import { ItemProps } from '../../organisms/FMTree/TypesForNodes';

class FMTreeItemNode extends React.Component<ItemProps> {

    public render() {
        return (
            <FMTreeNode
                level={this.props.level}
                selected={this.props.selected}
                selectNode={this.props.selectNode}
            >
                <FMIcon type="empty" color="secondary" />
                <FMCheckbox
                    checked={this.props.checked}
                    onClick={this.props.checked ? this.props.uncheckNode : this.props.checkNode}
                />
                <FMIcon type={this.props.nodeData.type as FMIconType} color="secondary" />
                <div className={this.props.classes.nodeName}>
                    {this.props.name}
                </div>
            </FMTreeNode>
        );
    }

}

export default withStyles(style)(FMTreeItemNodeWithStore(FMTreeItemNode));
